import React from "react";
import CajaGenerica from "./CajaGenerica";
import CajaVacia from "./CajaVacia";
const imagen = "balcon del pissis 1600x900.jpg";

export default function TursimoCerca() {
    return (
        <div className={"contenedor-paginas"}>
            <CajaVacia
                style={{position: "absolute", margin: "-55% 0px 0px"}}
                encabezado={"Alojamientos temporarios"}
                titulo={"Más que un alojamiento, una experiencia"}
                descripcion={"Experimenta la magia de Atacama, Catamarca y La Rioja, región conocida como AtaCaLaR, alojandote en algún punto de entrada al corazón de los Andes"}
                boton={"Leer más"}
            />
            <img className="contenedor-imagenes"
                style={{position: "absolute", margin: "-730px 0px 0px", width: "100%"}}
                 src={require(`../imagenes/${imagen}`)}
                 alt={`imagen `}
            />


            <div className="contenedor-principal">


                <CajaGenerica
                    icon={"argentina.png"}

                    titulo={"Turismo en la Provincia de Catamarca"}
                    texto={"Conocé los lugares más lindos de la provincia de Catamarca. Te ofrecemos una guía de turismo para que puedas disfrutar de tus vacaciones."}
                />
                <CajaGenerica
                    icon={"argentina.png"}
                    titulo={"Turismo en la Provincia de La Rioja"}
                    texto={"Conocé los lugares más lindos de la La Rioja. Te ofrecemos una guía de turismo para que puedas disfrutar de tus vacaciones."}
                />
                <CajaGenerica
                    icon={"chile.png"}
                    titulo={"Turismo en Atacama - Chile"}
                    texto={"Conocé los lugares más lindos de la Región de Atacama, Chile . Te ofrecemos una guía de turismo para que puedas disfrutar de tus vacaciones."}
                />

            </div>
        </div>
    );
}